import { Controller, useFormContext } from "react-hook-form";
import { useTranslation } from "react-i18next";
import { Input, Select } from "ui";

import {
  DescriptionAndSizesBlockProps,
  ProductFormValues
} from "../ProductDetailsForm.types";

import styles from "../ProductDetailsForm.module.scss";

export const DescriptionAndSizesBlock = ({
  defaultValues: _defaultValues,
  sizeAttribute
}: DescriptionAndSizesBlockProps) => {
  const { t } = useTranslation();
  const { control } = useFormContext<ProductFormValues>();

  const sizesOptions = sizeAttribute.values.map((att) => ({
    label: att.value,
    value: att.id as string
  }));

  return (
    <div className={styles.productForm__block}>
      <Controller
        control={control}
        name="description"
        render={({ field: { value, onChange }, fieldState: { error } }) => (
          <Input
            value={value}
            onChange={onChange}
            placeholder={t("Enter Product Description")}
            asTag="textarea"
            label={t("Product Description")}
            maxLength={250}
            errorMessage={error?.message}
          />
        )}
      />

      <Controller
        control={control}
        name="googleDriveLink"
        render={({ field: { value, onChange }, fieldState: { error } }) => (
          <Input
            value={value ?? ""}
            onChange={onChange}
            placeholder={t("Paste the Google Drive folder link")}
            label={t("Google Drive media link")}
            errorMessage={error?.message}
          />
        )}
      />

      <Controller
        control={control}
        name={"sizes"}
        render={({ field: { value, onChange }, fieldState: { error } }) => (
          <Select
            value={value.map((v) => v.sizeAttributeValueId)}
            label={t("Sizes available in this product")}
            placeholder={t("Choose Sizes")}
            onChange={(selectedValue) => {
              if (Array.isArray(selectedValue)) {
                onChange(
                  selectedValue.map((sizeId) => ({
                    sizeAttributeValueId: sizeId,
                    label: sizeAttribute.values.find(
                      (sizeAttValue) => sizeAttValue.id === sizeId
                    )?.value
                  }))
                );
              }
            }}
            options={sizesOptions}
            multiple
            errorMessage={error?.message}
          />
        )}
      />
    </div>
  );
};
